import { ContainerBtnNewCollection } from "./styles";
import ContentIcon from "@/shared/ContentIcon"; 


const BtnNewCollection = ({ onClick }) => {

    return (
        <ContainerBtnNewCollection onClick={onClick} className="container-btn-new-collection">
            <ContentIcon width= "18px" height="18px" nameIcon='plus-solid'/>
            <div className="titleCard"> CREAR COLECCIÓN</div>
        </ContainerBtnNewCollection>
    );
}

export default BtnNewCollection;